export enum ComparisonOperator {
  Equal = "=",
  LessThan = "<=",
  MoreThan = ">=",
}

export enum SortBy {
  NameAsc = "name_asc",
  NameDesc = "name_desc",
  CapacityAsc = "capacity_asc",
  CapacityDesc = "capacity_desc",
}

export enum SortByValue {
  name = "name",
  capacity = "capacity",
  operatorAsc = "asc",
  operatorDesc = "desc",
}

export enum FindFavoritePageType {
  MostUsed = "mostUsed",
  Favorite = "favorite",
}

export enum StatusResource {
  Available = "Available",
  All = "All",
}

export enum CategoryOperator {
  And = "And",
  Or = "Or",
}

export enum FilterTypeEnum {
  All = 0,
  Favorite = 1,
  MostUsed = 2,
}

export enum QuickTypeEnum {
  Colleagues = "Colleagues",
  Resources = "Resources",
}

export enum StatusIconType {
  UserVerified = "userVerified",
  AccessDenied = "accessDenied",
  AlertInfo = "alertInfo",
  AlertWarning = "alertWarning",
  AlertDanger = "alertDanger",
}

export enum PermissionTypeEnum {
  Accept = 1,
  DelegateByOutPolicy = 2,
  DelegateByInPolicy = 3,
  DeclinedByOutPolicy = 4,
  DeclinedByInPolicy = 5,
  VRConfigWrong = 6,
  DeniedInPolicyWorkspace = 7,
}

export enum PolicyTypeEnum {
  Inpolicy = 1,
  Outpolicy = 2,
  OutpolicyByEnforceSchedulingHorizon = 3,
  OutpolicyByBookingWindowInDays = 4,
  OutpolicyByMaximumDurationInMinutes = 5
}

export enum ClosingTimeTypeEnum {
  PreCloseDate = 1,
  CloseDate = 2
}

export enum ExchangeByRuleTypeEnum {
  CanBookByExchangeByRule = 1,
  CannotBookByExchangeByRule = 2,
}
